<div class="world-cloud-filter">
  <div class="container-multiselect">
    <ng-select
      [items]="dropdownList"
      bindLabel="name"
      bindValue="id"
      (ngModelChange)="onSelectionChanged($event)"
      [multiple]="true"
      [virtualScroll]="true"
      [(ngModel)]="selectedTagsList"
      [placeholder]="placeHolderString">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">{{ item.name }}</span>
        <span
          class="ng-value-icon right"
          (click)="toggleTag(item.name)"
          aria-hidden="true">
          ×
        </span>
      </ng-template>
    </ng-select>
  </div>
  <div class="container-word-cloud position-relative">
    <ng-container *ngIf="tags">
      <app-d3-word-cloud
        [disabledWords]="disabledWords"
        [highlightedWords]="highlightedWords"
        (clicked)="toggleTag($event)"
        [filteredWords]="filteredTags"
        [words]="tags"></app-d3-word-cloud>
      <div class="panel-info-tags">More tags in dropdown</div>
    </ng-container>
  </div>
</div>
